import React, { Component } from "react";
import Cookies from 'js-cookie';
import BottomLeftUI from './BottomLeft_UI.js';
import BottomRightUI from './BottomRight_UI.js';
import TopRightUI from './TopRight_UI.js';
import LiveMap from './LiveMap.js';
import NavigationMap from './NavigationMap.js';
import Logs from './Logs.js';
import CreateBoat from './CreateBoat.js';
import LoadingScreen from './LoadingScreen.js';

class Game extends Component {
    constructor(props) {
        super(props);
        this.toggleNavigationMap = this.toggleNavigationMap.bind(this);
        this.toggleLogs = this.toggleLogs.bind(this);
        this.createBoat = this.createBoat.bind(this);
        this.createLog = this.createLog.bind(this);
        this.deleteLog = this.deleteLog.bind(this);
        this.desiredBearingChange = this.desiredBearingChange.bind(this);

        this.state = {
            showNavigationMap: false,
            showLogs: false,
            createBoat: true,
            boatId: '',
            boatData: '',
            logs: '',
            getBoatDataClock: '',
            loadStatus: 'loading'
        }
    }
    componentDidMount() {
        this.getBoatList();

        const getBoatDataBound = this.getBoatData.bind(this);
        this.setState({ getBoatDataClock: setInterval(getBoatDataBound, 1000) });
    }
    componentWillUnmount() {
        clearInterval(this.state.getBoatDataClock);
    }
    render() {
        return (
            <div id="Game">
                <TopRightUI logOut={this.props.logOut} />

                {this.state.loadStatus == 'loaded' ?
                    <>
                        <LiveMap
                            boatData={this.state.boatData} portsData={this.state.portsData} />



                        <div className="bottomUI">
                            <BottomLeftUI
                                serverUrl={this.props.serverUrl}
                                boatData={this.state.boatData}
                                desiredBearingChange={this.desiredBearingChange}
                            />
                            <BottomRightUI
                                serverUrl={this.props.serverUrl}
                                showNavigationMap={this.state.showNavigationMap}
                                toggleNavigationMap={this.toggleNavigationMap}
                                toggleLogs={this.toggleLogs}
                                boatData={this.state.boatData}
                            />
                        </div>

                        {this.state.createBoat ? <CreateBoat createBoat={this.createBoat} /> : null}
                        <NavigationMap
                            logs={this.state.logs}
                        // boatData={this.state.boatData}
                        />
                        <Logs
                            boatData={this.state.boatData}
                            logs={this.state.logs}
                            createLog={this.createLog}
                            deleteLog={this.deleteLog}
                        />
                    </> : <LoadingScreen />}

            </div>
        );
    }

    // ========================================================================== //
    //  Toggle Navigation Map
    toggleNavigationMap() {
        const navMap = document.getElementById('navigationMap');
        if (!this.state.showNavigationMap) {
            navMap.style = 'transform:translateY(0vh)'
            this.getLogs();
        } else {
            navMap.style = 'transform:translateY(100vh)'
        }
        this.setState({ showNavigationMap: !this.state.showNavigationMap ? true : false });
    }

    // ========================================================================== //
    //  Toggle Logs
    toggleLogs() {
        const logsElement = document.getElementById('logs');
        if (!this.state.showLogs) {
            logsElement.style = 'opacity:1;transform:scale(100%) translate(0vw,0vh) rotate(0deg);'
            this.getLogs();
        } else {
            logsElement.style = 'opacity:0;transform:scale(0) translate(20vw,20vh) rotate(7deg);'
        }
        this.setState({ showLogs: !this.state.showLogs ? true : false });
    }


    // ========================================================================== //
    //  Create Boat
    createBoat(values) {
        const data = {
            name: values.boatName,
            type: '',
            lat: 37.935998,
            long: 23.614379
        }

        const options = {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            credentials: 'include',
            body: JSON.stringify(data)
        }

        fetch(this.props.serverUrl + "boat/new", options)
            .then(res => res.json().then(json => {
                console.log(json);
                this.getBoatList();
            }));
    }

    // ========================================================================== //
    //  Get Boat List
    getBoatList() {
        const options = {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json'
            },
            credentials: 'include',
        }
        // console.log(this.props.serverUrl)
        fetch(this.props.serverUrl + 'boat/list', options)
            .then(res => res.json().then(json => {
                if (!json.boats || json.boats.length === 0) {
                    this.setState({ createBoat: true, loadStatus: 'loaded' })
                    console.log('padbato');
                } else {
                    this.setState({ createBoat: false, boatId: json.boats[0]._id })

                    // this.getBoatData();

                }
            }))
            .catch(err => console.log(err));

    }

    // ========================================================================== //
    //  Get Boat Data
    getBoatData() {
        if (this.state.boatId && this.props.loggedIn) {
            const params = new URLSearchParams({ boatId: this.state.boatId })

            const options = {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json'
                },
                credentials: 'include',
            }
            // console.log('trying')
            fetch(this.props.serverUrl + 'boat/get?' + params, options)
                .then(res => res.json().then(json => {
                    this.setState({ loadStatus: 'loaded' })
                    this.storeBoatData(json.boat, json.ports);
                }))
                .catch(err => console.log(err));
        }
    }

    // ========================================================================== //
    //  Store Boat Data
    storeBoatData(boatData, portsData) {


        // Update uniquement le bataeu si les ports n'ont pas changé
        if (JSON.stringify(this.state.portsData) != JSON.stringify(portsData)) {
            this.setState({
                boatData: boatData,
                portsData: portsData
            }, () => { })
        } else {
            this.setState({
                boatData: boatData
            }, () => { })

        }
    }

    // ========================================================================== //
    //  Derired Bearing Change
    desiredBearingChange(value) {
        const data = {
            boatId: this.state.boatData._id,
            desiredBearing: value
        }

        const options = {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            credentials: 'include',
            body: JSON.stringify(data)
        }

        fetch(this.props.serverUrl + "boat/changeBearing", options)
            .then(res => res.json().then(json => {
                this.getBoatData();
            }));
    }

    // ========================================================================== //
    //  Get Logs
    getLogs() {
        if (this.state.boatData) {
            const params = new URLSearchParams({ boatId: this.state.boatData._id })

            const options = {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json'
                },
                credentials: 'include',
            }
            fetch(this.props.serverUrl + 'log/get?' + params, options)
                .then(res => res.json().then(json => {
                    // console.log(json.logs)
                    this.setState({ logs: json.logs })

                }))
                .catch(err => console.log(err));
        }
    }

    // ========================================================================== //
    //  Create Logs
    createLog(value) {
        const data = {
            boatId: this.state.boatData._id,
            logContent: value.logs_text
        }

        const options = {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            credentials: 'include',
            body: JSON.stringify(data)
        }
        fetch(this.props.serverUrl + "log/new", options)
            .then(res => res.json().then(json => {
                // console.log(json);
                this.getLogs()
                // if (json.message === 'json') {

                // }
            }));
    }

    // ========================================================================== //
    //  Delete Logs
    deleteLog(logId) {
        const data = {
            logId: logId
        }

        const options = {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            credentials: 'include',
            body: JSON.stringify(data)
        }
        fetch(this.props.serverUrl + "log/delete", options)
            .then(res => res.json().then(json => {
                this.getLogs()
            }));
    }

}


export default Game;
